import React from "react";

export const ProceedableOffer = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-296.000000, -58.000000)" fill="#353F52">
        <g
          id="icons_illustrated_proceedable_offer"
          transform="translate(296.000000, 58.000000)"
        >
          <path d="M33.5882,2.66426 C33.2375,2.40924 32.7625,2.40924 32.4118,2.66426 L13.2355,16.6107 C12.4593,17.1752 12,18.0771 12,19.0369 L12,24 C12,24.5523 11.5523,25 11,25 C10.4477,25 10,24.5523 10,24 L10,19.0369 C10,17.4372 10.7654,15.9341 12.0591,14.9932 L31.2355,1.04679 C32.2874,0.28173 33.7126,0.28173 34.7645,1.04679 L43,7.0362 L43,4 C43,3.44772 43.4477,3 44,3 L51,3 C51.5523,3 52,3.44772 52,4 L52,13.5817 L53.9409,14.9932 C55.2346,15.9341 56,17.4372 56,19.0369 L56,53 C56,54.6569 54.6569,56 53,56 L26,56 C25.4477,56 25,55.5523 25,55 C25,54.4477 25.4477,54 26,54 L53,54 C53.5523,54 54,53.5523 54,53 L54,19.0369 C54,18.0771 53.5407,17.1752 52.7645,16.6107 L33.5882,2.66426 Z M50,12.1271 L50,5 L45,5 L45,8.4908 L50,12.1271 Z" />
          <path
            d="M10,40 C10,37.7909 11.7909,36 14,36 C16.2091,36 18,37.7909 18,40 C18,40.5523 17.5523,41 17,41 C16.4477,41 16,40.5523 16,40 C16,38.8954 15.1046,38 14,38 C12.8954,38 12,38.8954 12,40 L12,42 L15,42 C15.5523,42 16,42.4477 16,43 C16,43.5523 15.5523,44 15,44 L12,44 L12,46 L17,46 C17.5523,46 18,46.4477 18,47 C18,47.5523 17.5523,48 17,48 L10,48 C9.4477,48 9,47.5523 9,47 C9,46.4477 9.4477,46 10,46 L10,40 Z"
            fillRule="nonzero"
          />
          <path d="M14,56 C21.732,56 28,49.732 28,42 C28,34.268 21.732,28 14,28 C6.268,28 0,34.268 0,42 C0,49.732 6.268,56 14,56 Z M14,54 C20.6274,54 26,48.6274 26,42 C26,35.3726 20.6274,30 14,30 C7.3726,30 2,35.3726 2,42 C2,48.6274 7.3726,54 14,54 Z" />
        </g>
      </g>
    </g>
  </svg>
);
